/*********************************************************
 * Copyright (C) 2020 VMware, Inc. All rights reserved.
 *********************************************************/

import { Component, Input } from '@angular/core';
import { AbstractModalComponent } from '../abstract-modal.component';

@Component({
   selector: 'cancel-confirm-dialog',
   templateUrl: './cancel-confirm-dialog.component.html',
   styles: [`
      /deep/ .modal.show .modal-dialog {
         width: 451.89px;
      }
   `]
 })

export class CancelConfirmDialogComponent extends AbstractModalComponent {

   @Input() public title;
   @Input() public message;
   @Input() public showWarning;
   @Input() public isTransferringFile;
   @Input() public buttonLabelConfirm?;
   @Input() public buttonLabelCancel?;

 }